import React from 'react';
import '../styles/MainBody.css';

const Services: React.FC = () => {
  return (
    <div style={{padding: '2rem'}}>
      <h1>Our Services</h1>
      <ul>
        <li><strong>Smart Lighting</strong> – Design and installation of smart lighting systems for homes and businesses.</li>
        <li><strong>Mesh Wi-Fi Networks</strong> – Setup and optimization of robust, whole-home mesh Wi-Fi solutions.</li>
        <li><strong>Home Automation</strong> – Integration of smart devices for seamless home automation experiences.</li>
        <li><strong>Basic Electrician Tasks</strong> –
          <ul>
            <li>Adding new light fittings</li>
            <li>Adding new plug sockets</li>
            <li>Fixing electrical faults</li>
            <li>Other general electrical work</li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default Services;
